import * as components from './components';
import * as selectors from './selectors';
import * as actions from './actions';
import * as routines from './redux-routines';

export default {
  components,
  selectors,
  actions,
  routines
};
